import * as types from '../types'

export default {
  state: {},
  getters: {},
  mutations: {
    [types.FCL_EDIT](state, FclData) {
      Object.assign(state, FclData)
    }
  },
  actions: {
    [types.FCL_EDIT]({ commit }, FclData) {
      commit(types.FCL_EDIT, FclData)
    }
  }
}
